import {isWithinDaysFromNow, isWithinYearsFromNow, formatDate} from '../DateUtil'

export default function LineItem (props) {
  const subscriptionCode = (subscriptionCodes) => {
    return (subscriptionCodes || []).find((sc) => {
      const matchesOrderId = props.order_id == sc.shopify_order_id
      const matchesItemId = props.id == sc.shopify_item_id
      const matchesIndex = props.quantity_index == sc.shopify_item_index
      return matchesOrderId && matchesItemId && matchesIndex
    })
  }

  const self = {
    isTemp: props.tempaccess == 1,
    isThirdParty: (subscriptionCodes) => !!subscriptionCode(subscriptionCodes),
    isInstructorCourse: props.sku && !!props.sku.match(/_INSC_FULL/),
    isOfficeHour: props.sku && !!props.sku.match(/_OH/),
    code: (subscriptionCodes) => {
      const sc = subscriptionCode(subscriptionCodes)
      return sc && sc.code
    },
    index: (subscriptionCodes) => {
      const sc = subscriptionCode(subscriptionCodes)
      return sc && props.quantity > 1 && sc.shopify_item_index + 1
    },
    idWithIndex: props.quantity_index ? `${props.id}-${props.quantity_index}` : props.id,
    isFulfilled: props.fulfillment_status == "fulfilled",
    isClassroom: !!props.class,
    isExtension: (enrollment) => props.properties && props.properties["_enrollment_to_extend"] == enrollment.id,
    orderId: props.order_id,
    needsPayment: false
  }

  self.matches = (enrollment) => {
    return (enrollment.shopify_order_id == props.order_id && enrollment.shopify_item_id == props.id)
  }

  return Object.assign({}, props, self)
}
